<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 复查列表 strat -->
      <el-tab-pane label="复查列表" name="first">
        <div class="block">
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="visionCheckData" border stripe class="mt15">
          <el-table-column prop="Checkname" label="检查人员姓名" width="70px"></el-table-column>
          <el-table-column prop="Inputname" label="录入人员姓名" width="70px"></el-table-column>
          <el-table-column prop="Inputtime" label="录入时间" width="100px"></el-table-column>
          <el-table-column prop="Datatype" label="录入类型" width="60px"></el-table-column>
          <el-table-column prop="DiopterstateName" label="屈光状态" width="50px"></el-table-column>
          <el-table-column prop="Interpupillary" label="瞳距" width="50px"></el-table-column>
          <el-table-column prop="Addtypef" label="ADD" width="50px"></el-table-column>
          <el-table-column prop="Amp" label="调节幅度" width="50px"></el-table-column>
          <el-table-column prop="Righteyedegree" label="球镜OD(右眼)" width="60px"></el-table-column>
          <el-table-column prop="Lefteyedegree" label="球镜OS(左眼)" width="60px"></el-table-column>
          <el-table-column prop="Rightcolumnmirror" label="柱镜OD(右眼)" width="60px"></el-table-column>
          <el-table-column prop="Leftcolumnmirror" label="柱镜OS(左眼)" width="60px"></el-table-column>
          <el-table-column prop="Rightaxial" label="轴向OD(右眼)" width="60px"></el-table-column>
          <el-table-column prop="Leftaxial" label="轴向OS(左眼)" width="60px"></el-table-column>
          <el-table-column prop="Nakedrighteyedegree" label="裸眼视力OD(右眼)" width="70px"></el-table-column>
          <el-table-column prop="Nakedlefteyedegree" label="裸眼视力OS(左眼)" width="70px"></el-table-column>
          <el-table-column prop="Nakedbinoculusdegree" label="裸眼视力OU(双眼)" width="70px"></el-table-column>
          <el-table-column prop="Correctrighteyedegree" label="最佳矫正视力OD(右眼)" width="70px"></el-table-column>
          <el-table-column prop="Correctlefteyedegree" label="最佳矫正视力OS(左眼)" width="70px"></el-table-column>
          <el-table-column prop="Correctbinoculusdegree" label="最佳矫正视力OU(双眼)" width="70px"></el-table-column>
          <el-table-column prop="Adminname" label="管理员姓名" width="60px"></el-table-column>
          <el-table-column prop="operation" label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickm(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 复查列表 end -->

      <!-- 添加视光复查 start -->
      <el-tab-pane label="添加视光复查" name="second">
        <el-form :model="addFuCha" ref="addFuChaRef" label-width="68px">
          <el-form-item label="检查人员" class="addAdminForm">
            <el-input v-model="addFuCha.checkname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="录入人员" class="addAdminForm">
            <el-input v-model="addFuCha.inputname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="录入时间" class="addAdminForm">
            <el-date-picker v-model="addFuCha.inputtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>

          <div class="optometry">
            <el-form-item label="屈光状态" class="select2">
              <el-select v-model="addFuCha.diopterstate" placeholder="请选择" style="width: 100%">
                <el-option label="请选择" value="0"></el-option>
                <el-option label="正视" value="6"></el-option>
                <el-option label="远视" value="2"></el-option>
                <el-option label="近视" value="1"></el-option>
                <el-option label="散光" value="7"></el-option>
                <el-option label="老花" value="3"></el-option>
                <el-option label="屈光参差" value="8"></el-option>
                <el-option label="远视性弱视" value="9"></el-option>
                <el-option label="散光性弱视" value="10"></el-option>
                <el-option label="近视性弱视" value="11"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 视光信息 end -->

          <!-- 屈光度 -->
          <el-table :data="diopterData" border stripe class="mt20">
            <el-table-column label="屈光度" align="center">
              <el-table-column label="OD(右眼)" align="center">
                <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addFuCha.righteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addFuCha.rightcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="addFuCha.rightaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="OS(左眼)" align="center">
                <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addFuCha.lefteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addFuCha.leftcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="addFuCha.leftaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- ADD和调节幅度 -->
          <el-table :data="addData" border stripe class="mt20">
            <el-table-column label="ADD和调节幅度" align="center">
              <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                <template slot-scope="scope">
                  <el-select v-model="addFuCha.addtype" placeholder="请选择" style="width: 100%">
                    <el-option label="0.00D" value="0"></el-option>
                    <el-option label="0.50D" value="1"></el-option>
                    <el-option label="0.75D" value="2"></el-option>
                    <el-option label="1.00D" value="3"></el-option>
                    <el-option label="1.25D" value="4"></el-option>
                    <el-option label="1.50D" value="5"></el-option>
                    <el-option label="1.75D" value="6"></el-option>
                    <el-option label="2.00D" value="7"></el-option>
                    <el-option label="2.25D" value="8"></el-option>
                    <el-option label="2.50D" value="9"></el-option>
                    <el-option label="2.75D" value="10"></el-option>
                    <el-option label="3.00D" value="11"></el-option>
                    <el-option label="3.25D" value="12"></el-option>
                    <el-option label="3.50D" value="13"></el-option>
                    <el-option label="3.75D" value="14"></el-option>
                    <el-option label="4.00D" value="15"></el-option>
                    <el-option label="4.25D" value="16"></el-option>
                    <el-option label="4.50D" value="17"></el-option>
                    <el-option label="4.75D" value="18"></el-option>
                    <el-option label="5.00D" value="19"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="adjust" label="调节幅度(范围:0.00D~+22.00D)">
                <template slot-scope="scope">
                  <el-input v-model="addFuCha.amp"></el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 裸眼和矫正视力 -->
          <el-table :data="nakedEye" border stripe class="mt20">
            <el-table-column label="5m裸眼视力(5分记录法)" align="center">
              <el-table-column prop="odRight" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addFuCha.nakedrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addFuCha.nakedlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addFuCha.nakedbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="最佳矫正视力(5分记录法)" align="center">
              <el-table-column prop="odRight1" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addFuCha.correctrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft1" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addFuCha.correctlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble1" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addFuCha.correctbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 瞳距，内透镜规格 -->
          <el-table :data="tongJuData" border stripe class="mt20">
            <el-table-column  prop="tongju" label="瞳距(单位:mm)">
              <template slot-scope="scope">
                <el-input v-model="addFuCha.interpupillary"></el-input>
              </template>
            </el-table-column>
          </el-table>

          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn1">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加视光复查 end -->

      <!-- 修改视光复查 start -->
      <el-tab-pane label="修改视光复查" name="three" disabled>
        <el-form :model="editFuCha" ref="editFuChaRef" label-width="68px">
          <el-form-item label="检查人员" class="addAdminForm">
            <el-input v-model="editFuCha.checkname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="录入人员" class="addAdminForm">
            <el-input v-model="editFuCha.inputname" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="录入时间" class="addAdminForm">
            <el-date-picker v-model="editFuCha.inputtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>

          <div class="optometry">
            <el-form-item label="屈光状态" class="select2">
              <el-select v-model="editFuCha.diopterstate" placeholder="请选择" style="width: 100%">
                <el-option label="请选择" value="0"></el-option>
                <el-option label="正视" value="6"></el-option>
                <el-option label="远视" value="2"></el-option>
                <el-option label="近视" value="1"></el-option>
                <el-option label="散光" value="7"></el-option>
                <el-option label="老花" value="3"></el-option>
                <el-option label="屈光参差" value="8"></el-option>
                <el-option label="远视性弱视" value="9"></el-option>
                <el-option label="散光性弱视" value="10"></el-option>
                <el-option label="近视性弱视" value="11"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- 视光信息 end -->

          <!-- 屈光度 -->
          <el-table :data="diopterData" border stripe class="mt20">
            <el-table-column label="屈光度" align="center">
              <el-table-column label="OD(右眼)" align="center">
                <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="editFuCha.righteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="editFuCha.rightcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="editFuCha.rightaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="OS(左眼)" align="center">
                <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="editFuCha.lefteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="editFuCha.leftcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="editFuCha.leftaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- ADD和调节幅度 -->
          <el-table :data="addData" border stripe class="mt20">
            <el-table-column label="ADD和调节幅度" align="center">
              <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                <template slot-scope="scope">
                  <el-select v-model="editFuCha.addtype" placeholder="请选择" style="width: 100%">
                    <el-option label="0.00D" value="0"></el-option>
                    <el-option label="0.50D" value="1"></el-option>
                    <el-option label="0.75D" value="2"></el-option>
                    <el-option label="1.00D" value="3"></el-option>
                    <el-option label="1.25D" value="4"></el-option>
                    <el-option label="1.50D" value="5"></el-option>
                    <el-option label="1.75D" value="6"></el-option>
                    <el-option label="2.00D" value="7"></el-option>
                    <el-option label="2.25D" value="8"></el-option>
                    <el-option label="2.50D" value="9"></el-option>
                    <el-option label="2.75D" value="10"></el-option>
                    <el-option label="3.00D" value="11"></el-option>
                    <el-option label="3.25D" value="12"></el-option>
                    <el-option label="3.50D" value="13"></el-option>
                    <el-option label="3.75D" value="14"></el-option>
                    <el-option label="4.00D" value="15"></el-option>
                    <el-option label="4.25D" value="16"></el-option>
                    <el-option label="4.50D" value="17"></el-option>
                    <el-option label="4.75D" value="18"></el-option>
                    <el-option label="5.00D" value="19"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="adjust" label="调节幅度(范围:0.00D~+22.00D)">
                <template slot-scope="scope">
                  <el-input v-model="editFuCha.amp"></el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 裸眼和矫正视力 -->
          <el-table :data="nakedEye" border stripe class="mt20">
            <el-table-column label="5m裸眼视力(5分记录法)" align="center">
              <el-table-column prop="odRight" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="editFuCha.nakedrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="editFuCha.nakedlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="editFuCha.nakedbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="最佳矫正视力(5分记录法)" align="center">
              <el-table-column prop="odRight1" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="editFuCha.correctrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft1" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="editFuCha.correctlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble1" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="editFuCha.correctbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 瞳距，内透镜规格 -->
          <el-table :data="tongJuData" border stripe class="mt20">
            <el-table-column  prop="tongju" label="瞳距(单位:mm)">
              <template slot-scope="scope">
                <el-input v-model="editFuCha.interpupillary"></el-input>
              </template>
            </el-table-column>
          </el-table>

          <el-form-item class="mt20">
            <el-button type="primary" @click="clickModify">保存</el-button>
            <el-button type="info" @click="clickreturn2">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 修改视光复查 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataListnum: 0,
      value1: '',
      value2: '',
      visionCheckData: [],
      addFuCha: {
        checkname: '',
        inputname: '',
        inputtime: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        addtype: '0',
        amp: '0.00',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: ''
      },
      editFuCha: {
        id: '',
        checkname: '',
        inputname: '',
        inputtime: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        addtype: '0',
        amp: '0.00',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: ''
      },
      diopterData: [
        {
          rightEye1: '右眼',
          rightEye2: '右眼',
          rightEye3: '右眼',
          leftEye1: '右眼',
          leftEye2: '右眼',
          leftEye3: '右眼'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: 'add',
          adjust: '调节幅度'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '请选择', osLeft: '请选择', ouDouble: '请选择', odRight1: '请选择', osLeft1: '请选择', ouDouble1: '请选择' }
      ],
      tongJuData: [
        { tongju: '请输入', leftEye: '请选择', rightEye: '请选择' }
      ],
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ],
      neizhitjgglist: [
        { value: '8', label: '无' },
        { value: '1', label: 'A' },
        { value: '2', label: 'B' },
        { value: '3', label: 'C' },
        { value: '4', label: 'D' },
        { value: '5', label: 'E' },
        { value: '6', label: 'F' },
        { value: '7', label: '其他' }
      ],
      Display_ModifyEyeInfo: false,
      parentdata: null
    }
  },
  mounted () {
    this.addFuCha.inputtime = Vue.prototype.FunGetTimeStringLong()
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apiRuiYunGetRslEvFuChaNum()
      this.apiRuiYunGetRslEvFuChaList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiRuiYunGetRslEvFuChaList()
    },
    clickreturn1 () {
      this.activeName = 'first'
    },
    clickreturn2 () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.apiRuiYunAddRslEvFuCha()
    },
    clickm (row) {
      this.editFuCha.id = row.Id
      this.editFuCha.checkname = row.Checkname
      this.editFuCha.inputname = row.Inputname
      this.editFuCha.inputtime = row.Inputtime
      this.editFuCha.diopterstate = row.Diopterstate.toString()
      this.editFuCha.righteyedegree = row.Righteyedegree
      this.editFuCha.rightcolumnmirror = row.Rightcolumnmirror
      this.editFuCha.rightaxial = row.Rightaxial
      this.editFuCha.lefteyedegree = row.Lefteyedegree
      this.editFuCha.leftcolumnmirror = row.Leftcolumnmirror
      this.editFuCha.leftaxial = row.Leftaxial
      this.editFuCha.addtype = row.Addtype.toString()
      this.editFuCha.amp = row.Amp
      this.editFuCha.nakedrighteyedegree = row.Nakedrighteyedegree
      this.editFuCha.nakedlefteyedegree = row.Nakedlefteyedegree
      this.editFuCha.nakedbinoculusdegree = row.Nakedbinoculusdegree
      this.editFuCha.correctrighteyedegree = row.Correctrighteyedegree
      this.editFuCha.correctlefteyedegree = row.Correctlefteyedegree
      this.editFuCha.correctbinoculusdegree = row.Correctbinoculusdegree
      this.editFuCha.interpupillary = row.Interpupillary
      this.Display_ModifyEyeInfo = true
      this.activeName = 'three'
    },
    clickModify () {
      this.apiRuiYunEditRslEvFuCha()
    },
    apiRuiYunGetRslEvFuChaList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        pageno: that.selectedPageNo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiYunGetRslEvFuChaList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.visionCheckData = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiYunGetRslEvFuChaNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiYunGetRslEvFuChaNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiYunAddRslEvFuCha: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        checkname: that.addFuCha.checkname,
        inputname: that.addFuCha.inputname,
        diopterstate: that.addFuCha.diopterstate,
        righteyedegree: that.addFuCha.righteyedegree,
        rightcolumnmirror: that.addFuCha.rightcolumnmirror,
        rightaxial: that.addFuCha.rightaxial,
        lefteyedegree: that.addFuCha.lefteyedegree,
        leftcolumnmirror: that.addFuCha.leftcolumnmirror,
        leftaxial: that.addFuCha.leftaxial,
        addtype: that.addFuCha.addtype,
        amp: that.addFuCha.amp,
        nakedrighteyedegree: that.addFuCha.nakedrighteyedegree,
        nakedlefteyedegree: that.addFuCha.nakedlefteyedegree,
        nakedbinoculusdegree: that.addFuCha.nakedbinoculusdegree,
        correctrighteyedegree: that.addFuCha.correctrighteyedegree,
        correctlefteyedegree: that.addFuCha.correctlefteyedegree,
        correctbinoculusdegree: that.addFuCha.correctbinoculusdegree,
        interpupillary: that.addFuCha.interpupillary,
        inputtime: that.addFuCha.inputtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiYunAddRslEvFuCha, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.addFuCha.checkname = ''
            that.addFuCha.inputname = ''
            that.addFuCha.inputtime = ''
            that.addFuCha.diopterstate = '0'
            that.addFuCha.righteyedegree = '0.00'
            that.addFuCha.rightcolumnmirror = '0.00'
            that.addFuCha.rightaxial = '0'
            that.addFuCha.lefteyedegree = '0.00'
            that.addFuCha.leftcolumnmirror = '0.00'
            that.addFuCha.leftaxial = '0'
            that.addFuCha.addtype = '0'
            that.addFuCha.amp = '0.00'
            that.addFuCha.nakedrighteyedegree = '0'
            that.addFuCha.nakedlefteyedegree = '0'
            that.addFuCha.nakedbinoculusdegree = '0'
            that.addFuCha.correctrighteyedegree = '0'
            that.addFuCha.correctlefteyedegree = '0'
            that.addFuCha.correctbinoculusdegree = '0'
            that.addFuCha.interpupillary = ''

            that.activeName = 'first'
            that.apiRuiYunGetRslEvFuChaNum()
            that.apiRuiYunGetRslEvFuChaList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiRuiYunEditRslEvFuCha: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fuchaid: that.editFuCha.id,
        checkname: that.editFuCha.checkname,
        inputname: that.editFuCha.inputname,
        diopterstate: that.editFuCha.diopterstate,
        righteyedegree: that.editFuCha.righteyedegree,
        rightcolumnmirror: that.editFuCha.rightcolumnmirror,
        rightaxial: that.editFuCha.rightaxial,
        lefteyedegree: that.editFuCha.lefteyedegree,
        leftcolumnmirror: that.editFuCha.leftcolumnmirror,
        leftaxial: that.editFuCha.leftaxial,
        addtype: that.editFuCha.addtype,
        amp: that.editFuCha.amp,
        nakedrighteyedegree: that.editFuCha.nakedrighteyedegree,
        nakedlefteyedegree: that.editFuCha.nakedlefteyedegree,
        nakedbinoculusdegree: that.editFuCha.nakedbinoculusdegree,
        correctrighteyedegree: that.editFuCha.correctrighteyedegree,
        correctlefteyedegree: that.editFuCha.correctlefteyedegree,
        correctbinoculusdegree: that.editFuCha.correctbinoculusdegree,
        interpupillary: that.editFuCha.interpupillary,
        inputtime: that.editFuCha.inputtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_RuiYunEditRslEvFuCha, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.Display_ModifyEyeInfo = false
            that.apiRuiYunGetRslEvFuChaList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
